module.exports = __webpack_public_path__ + "static/media/accomodation-1920.b1bc98a4.jpg";